import { FC, memo, useContext } from "react";
import { iViewBoxProps } from "./LineChart.helpers";
import { iAxisYPoint } from "./LineChartAxisY";
import { LineChartThemeContext } from "./LineChartTheme.context";

interface iProps {
    viewport: iViewBoxProps;
    yAxisData: iAxisYPoint[];
}

const LineChartGrid: FC<iProps> = ({
    viewport,
    yAxisData,
}) => {
    const { THEME } = useContext(LineChartThemeContext);
    return (
        <g name="chart-grid">
            {yAxisData.map((point,index) => (
                <line
                    key={`ChartGrid-${point.y}-${index}`}
                    strokeWidth={0.5}
                    x1={0}
                    x2={viewport.width}
                    y1={point.y}
                    y2={point.y}
                    stroke={THEME.GRID}
                />
            ))}
        </g>
    )
}

export default memo(LineChartGrid);